export default __webpack_public_path__ + "static/media/proIconLoading.8998a3ed.svg";